import React, {useState} from 'react';
import {Box, Typography} from '@mui/material';
import './ScrubCharacter.scss';
import ArrButton from '../../../common/arr-button/ArrButton';
import ArrSingleSelectDropdown from '../../../common/arr-select-dropdown/ArrSingleSelectDropdown';
import {t} from 'i18next';
import ArrIconButton from '../../../common/arr-icon-button/ArrIconButton';
import * as deleteSvg from '../../../../assets/images/delete.svg';

import {ReactComponent as PlusIcon} from '../../../../assets/images/plus-icon.svg';
type fieldType = {
  id: string;
  name: string;
  label: string;
  fieldDefault: string;
  newLineDefault: string;
  textDefault: string;
}[];
type scrubtype = {
  specialCharId: string;
  specialCharName: string;
  specialCharLabel: string;
  replacementCharId: string;
  replacementCharName: string;
  replacementCharLabel: string;
}[];
export type ScrubCharacterProps = {
  fieldList: fieldType;
  replaceFieldList: fieldType;
  scrubCharList: scrubtype;
  onScrubCharListUpdate: (scrubData: scrubtype) => void;
  onCancel: () => void;
};

const ScrubCharacter: React.FC<ScrubCharacterProps> = ({
  fieldList,
  scrubCharList,
  replaceFieldList,
  onScrubCharListUpdate,
  onCancel,
}) => {
  const [scrubList, setScrubList] = useState<scrubtype>(scrubCharList);

  const handleSelected = (index: number, name: string, item: any) => {
    if (name == 'specialCharName') {
      if (item != undefined) {
        setScrubList((prev) =>
          prev.map((obj, i) =>
            i === index
              ? {
                  ...obj,
                  specialCharName: item?.specialCharName,
                  specialCharId: item?.id,
                }
              : obj
          )
        );
      }
    } else if (name == 'replacementCharName') {
      if (item != undefined) {
        setScrubList((prev) =>
          prev.map((obj, i) =>
            i === index
              ? {
                  ...obj,
                  replacementCharName: item?.replacementCharName,
                  replacementCharId: item?.id,
                }
              : obj
          )
        );
      }
    }
  };

  const handleAddNew = () => {
    const newScrubData = {
      specialCharId: '44',
      specialCharName: '[,] 044',
      specialCharLabel: ',',
      replacementCharId: '32',
      replacementCharName: '[ ] 032',
      replacementCharLabel: ' ',
    };
    setScrubList((prev) => [...prev, newScrubData]);
  };

  const handleDeleteRow = (index: number) => {
    setScrubList((prev) => prev.filter((_, i) => i !== index));
  };
  const handleClose = () => {
    onCancel();
  };
  const handleApply = () => {
    onScrubCharListUpdate(scrubList);
  };

  return (
    <>
      {' '}
      <Box className="header-wrapper">
        <Box className="drawer-header">
          <Typography
            className="typo-text headline3_size text1"
            data-testid={`scrub-character-scrub-spl-character-title`}>
            {t('dataExportReport.scrubSplCharacterTitle')}
          </Typography>
        </Box>

        <Box className="action-buttons-box">
          <ArrButton
            variant="secondary"
            size="medium"
            onClick={handleClose}
            disabled={false}
            aria-label={t('common.cancel')}
            dataTestId="scrub-character-cancel-button"
          >
            {t('common.cancel')}
          </ArrButton>
          <ArrButton
            disabled={false}
            variant="primary"
            size="medium"
            type="submit"
            aria-label={t('common.apply')}
            dataTestId="apply-button"
            onClick={handleApply}
          >
            {t('common.apply')}
          </ArrButton>
        </Box>
      </Box>
      <Box className="body-wrapper">
        <Box className="discriptionText">
          {t('dataExportReport.scrubSplCharacterDiscrip')}
        </Box>
        <Box className="scrubInputWrapper">
          <Box className="inputHeader scrubInput">
            <Typography
              className="typo-text subhead4_size count"
              data-testid="total-docs"
            >
              {t('dataExportReport.specialChar')}
            </Typography>
          </Box>

          <Box className="inputHeader scrubInput">
            <Typography
              className="typo-text subhead4_size count"
              data-testid="total-docs"
            >
              {t('dataExportReport.replacementChar')}
            </Typography>
          </Box>
        </Box>

        {scrubList?.map((list, index) => (
          <Box className="scrubInputWrapper">
            <Box className="scrubInput">
              <Box className="scrubInputContainer">
                <ArrSingleSelectDropdown
                  selectedValues={scrubList[index]}
                  dropdownLabel={''}
                  sizeVariant="medium"
                  customWidth={10}
                  dropdownItems={fieldList}
                  dropdownItemKey="id"
                  dropdownItemDisplay="specialCharName"
                  onSelectionChange={(item) =>
                    handleSelected(index, 'specialCharName', item)
                  }
                  dataTestId={`special-character-dropdown-${index + 1}`}
                />
              </Box>
            </Box>
            <Box className="scrubInput">
              <Box className="scrubInputContainer1">
                <ArrSingleSelectDropdown
                  selectedValues={scrubList[index]}
                  dropdownLabel={''}
                  sizeVariant="medium"
                  dropdownItems={replaceFieldList}
                  dropdownItemKey="id"
                  dropdownItemDisplay="replacementCharName"
                  customWidth={10}
                  onSelectionChange={(item) => {
                    handleSelected(index, 'replacementCharName', item);
                  }}
                  dataTestId={`replacement-character-dropdown-${index + 1}`}
                />
                <ArrIconButton
                  icon={<deleteSvg.ReactComponent />}
                  onClick={() => handleDeleteRow(index)}
                  ariaLabel={''}
                  className="delete-button"
                  testId={`scrub-character-icon-button-${index + 1}`}
                />
              </Box>
            </Box>
          </Box>
        ))}

        <Box className="scrubInputWrapper">
          <ArrButton
            disabled={false}
            variant="primary"
            size="medium"
            type="submit"
            className={'add-button'}
            startIcon={<PlusIcon />}
            aria-label={t('common.addNew')}
            dataTestId="add-new"
            onClick={handleAddNew}
          >
            {t('common.addNew')}
          </ArrButton>
        </Box>
      </Box>
    </>
  );
};

export default ScrubCharacter;
